import { useEffect, useState } from 'react'
import { useWeb3React } from '@web3-react/core'
import { InjectedConnector } from '@web3-react/injected-connector'
import { WalletConnectConnector } from '@web3-react/walletconnect-connector'

function MetamaskProvider({ children }) {
  const { active: networkActive, error: networkError, activate: activateNetwork } = useWeb3React()
  const [loaded, setLoaded] = useState(false)
  const injected = new InjectedConnector({ supportedChainIds: [56, 97] })

  const POLLING_INTERVAL = 3000
  const wcConnector = new WalletConnectConnector({
    rpc: {
      56: "https://bsc-dataseed1.binance.org"
    },
    chainId: 56,
    network: "binance",
    qrcode: true,
    qrcodeModalOptions: {
      mobileLinks: [
        "metamask",
        "trust"
      ]
    },
    pollingInterval: POLLING_INTERVAL
  })

  wcConnector.networkId = 56

  useEffect(() => {

    const userData = window.localStorage.getItem('userData')
    if (userData) {
      const userDataObj = JSON.parse(userData)
      if (userDataObj.provider === 'injected' && userDataObj.isLoggedIn) {
        injected
          .isAuthorized()
          .then((isAuthorized) => {
            setLoaded(true)
            if (isAuthorized && !networkActive && !networkError) {
              activateNetwork(injected)
            }
          })
          .catch(() => {
            setLoaded(true)
          })
      }

      if (userDataObj.provider === 'walletconnect' && userDataObj.isLoggedIn) {
        if (!networkActive && !networkError) {
          activateNetwork(wcConnector)
        }
      }
    }

  }, [activateNetwork, networkActive, networkError])
  if (loaded) {
    return children
  }
  return children
}

export default MetamaskProvider